module.exports = __webpack_public_path__ + "static/chart-3_animation-5abcd925d6ca1f830749e0652a695274.mp4";